import { useEffect, useState } from "react";
import { WeaknessInstanceData, getWeaknessInstance } from "../remote/scan_data"
import { Button, CircularProgress, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getSupplier, SupplierData } from "../remote/suppliers";

export interface WeaknessInstanceProps {
	id: string
	supplier: string | undefined
	data?: WeaknessInstanceData | undefined
	hideChildren?: boolean
}

export const WeaknessInstanceSimple = ({id, supplier=undefined, data=undefined}: WeaknessInstanceProps) => {
	const navigate = useNavigate()

	const [supplierData, setSupplierData] = useState<SupplierData | null | undefined>((supplier == undefined) ? null : undefined);
	useEffect(() => {
		if (data == undefined) {
			getSupplier(id, (data, resp) => {
				if (data) {
					setSupplierData(data);
				} else {
					setSupplierData(null);
				}
			});
		}
	}, [setSupplierData, supplier]);

	const [weaknessData, setWeaknessInstanceData] = useState<WeaknessInstanceData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getWeaknessInstance(id, (data, resp) => {
				if (data) {
					setWeaknessInstanceData(data);
				} else {
					setWeaknessInstanceData(null);
				}
			});
		}
	}, [setWeaknessInstanceData]);

	return (weaknessData
		? <>
			{((supplierData == undefined) ? <CircularProgress /> : (supplierData != null ? <Typography variant="body1">{supplierData.name}</Typography> : <></>))}
			<Button sx={{float: 'left'}} onClick={() => navigate(`/tree/weakness/${id}`)}>
				<Stack direction={'column'}>
					<Typography sx={{wordBreak: 'break-all'}}>
					{weaknessData.weakness?.cwe_id ?? "Missing CWE"} - {weaknessData.weakness?.severity ?? ''}
					</Typography> <br />
					<Typography sx={{wordBreak: 'break-all', textTransform: 'none'}}>
					{weaknessData.location} {weaknessData.location.length > 0 ? <br /> : <></>}
					{weaknessData.remediation} <br />
					{weaknessData.weakness?.description ?? ''}
					</Typography>
				</Stack>
			</Button>
		</>
		: <CircularProgress />
	)
}

export const WeaknessInstance = ({id, data=undefined, hideChildren=false}: WeaknessInstanceProps) => {
	const navigate = useNavigate()

	const [weaknessData, setWeaknessInstanceData] = useState<WeaknessInstanceData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getWeaknessInstance(id, (data, resp) => {
				if (data) {
					setWeaknessInstanceData(data);
				} else {
					setWeaknessInstanceData(null);
				}
			});
		}
	}, [setWeaknessInstanceData]);

	return (weaknessData
		?
		<TableContainer component={Paper}>
			<Table width={hideChildren ? 'auto' : '100%'}>
				<TableHead>
					<TableRow>
						<TableCell>
							<Typography variant="h5">Weakness</Typography>
						</TableCell>
						<TableCell align='right'>
							{hideChildren ? (<></>) :
							(weaknessData.children.length > 0 ?
							<Button onClick={() => navigate(`/tree/ip/${id}`)}>See children</Button>
							: <Button disabled>No children</Button>)}
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{weaknessData.weakness
						? <>
							<TableRow><TableCell align='left'>CWE</TableCell><TableCell align='right'>{weaknessData.weakness.cwe_id}</TableCell></TableRow>
							<TableRow><TableCell align='left'>Severity</TableCell><TableCell align='right'>{weaknessData.weakness.severity}</TableCell></TableRow>
							<TableRow><TableCell align='left'>Description</TableCell><TableCell align='right'>{weaknessData.weakness.description}</TableCell></TableRow>
							<TableRow><TableCell align='left'>CVSS Score</TableCell><TableCell align='right'>{weaknessData.weakness.cvss_score}</TableCell></TableRow>
							<TableRow><TableCell align='left'>CVSS Metrics</TableCell><TableCell align='right'>{weaknessData.weakness.cvss_metrics}</TableCell></TableRow>
						</>
						: <></>
					}
					<TableRow><TableCell align='left'>Location</TableCell><TableCell align='right'>{String(weaknessData.location)}</TableCell></TableRow>
					<TableRow><TableCell align='left'>Remediation</TableCell><TableCell align='right'>{String(weaknessData.remediation)}</TableCell></TableRow>
					<TableRow><TableCell align='left'>First seen</TableCell><TableCell align='right'>{String(weaknessData.first_seen)}</TableCell></TableRow>
					<TableRow><TableCell align='left'>Last seen</TableCell><TableCell align='right'>{String(weaknessData.last_seen)}</TableCell></TableRow>
				</TableBody>
			</Table>
			</TableContainer>
		: <CircularProgress />
	)
}
